export const FIGMA_APP_ID = 'com.figma.jira-add-on';
export const FIGMA_APP_ID_STG = 'com.figma.jira-add-on-dev';
export const DEFAULT_WORKSPACE = 'main';
